import { ENV_LOCAL, ENV_BRANCH, ENV_NEXT, ENV_PRODUCTION } from "hooks/useWhen";

export const PAYMENT_ARGS = {
  env: [ENV_PRODUCTION, ENV_LOCAL, ENV_BRANCH, ENV_NEXT],
};
